/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
/* eslint-disable react/prop-types */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import SubscriptionQuery from 'Query/Subscription.query';
import { setSiteBaseLoaded } from 'Store/Config/Config.action';
import { fetchQuery } from 'Util/Request/Query';
import { getQueryParam } from 'Util/Url';

import UnsubscribeComponent from './Unsubscribe.component';

/** @namespace Scandipwa/Route/Unsubscribe/Container/mapStateToProps */
export const mapStateToProps = () => ({});

/** @namespace Scandipwa/Route/Unsubscribe/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    setBaseSiteLoaded: () => dispatch(setSiteBaseLoaded())
});

/** @namespace Scandipwa/Route/Unsubscribe/Container */
export class UnsubscribeContainer extends PureComponent {
    state = {
        isLoading: true
    };

    componentDidMount() {
        const { setBaseSiteLoaded } = this.props;

        const params = this.parseUri();
        const {
            hash,
            uid,
            cid,
            llid
        } = params;

        fetchQuery(SubscriptionQuery.getEmarsysUnsubscribeQuery(hash, uid, cid, llid)).then(
            /** @namespace Scandipwa/Route/Unsubscribe/Container/UnsubscribeContainer/componentDidMount/fetchQuery/then */
            ({ EmarsysUnsubscribe }) => {
                this.setState({
                    isLoading: false,
                    isUnsubscribed: EmarsysUnsubscribe
                });
            },
            this._handleError
        );

        setBaseSiteLoaded();
    }

    parseUri() {
        const params = {};
        params.hash = getQueryParam('hash', window.location);
        params.uid = getQueryParam('uid', window.location);
        params.cid = getQueryParam('cid', window.location);
        params.llid = getQueryParam('llid', window.location);

        return params;
    }

    render() {
        return (
            <UnsubscribeComponent { ...this.state } />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UnsubscribeContainer);
